module.exports = __webpack_public_path__ + "static/img/head.37bacfa0.png";